module.exports = __webpack_public_path__ + "fonts/StdKaiXHYL2EG-Md.eot";